import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="legal-page" style={{ 
      padding: '20px', 
      maxWidth: '800px', 
      margin: '0 auto', 
      fontFamily: "'Inter', sans-serif",
      textAlign: 'center' // Center-align all text
    }}>
      {/* Back button at the top */}
      <div style={{ margin: '20px 0' }}>
        <Link to="/" style={{ 
          display: 'inline-block', 
          padding: '10px 20px', 
          backgroundColor: '#9CDAED', 
          color: 'black', 
          textDecoration: 'none', 
          borderRadius: '8px',
          fontWeight: 'bold'
        }}>
          Return to Home
        </Link>
      </div>
      
      <h1>Terms of Service</h1>
      <p>Last Updated: April 23, 2025</p>
      
      <div style={{ textAlign: 'left' }}> {/* Keep content left-aligned for readability */}
        <h2>1. Introduction</h2>
        <p>Welcome to Links, an AI-powered math tutoring application. These Terms of Service ("Terms") govern your access to and use of our website, mobile applications, and services (collectively, the "Service"). By accessing or using the Service, you agree to be bound by these Terms.</p>
        
        <h2>2. Using Our Services</h2>
        <p>You must follow any policies made available to you within the Service. You may use our Service only as permitted by law. We may suspend or stop providing our Service to you if you do not comply with our terms or policies or if we are investigating suspected misconduct.</p>
        
        <h2>3. Account Registration</h2>
        <p>To access certain features of the Service, you may be required to register for an account. You agree to provide accurate, current, and complete information during the registration process and to update such information to keep it accurate, current, and complete.</p>
        
        <h2>4. AI Tutoring Services</h2>
        <p>Our Service uses artificial intelligence to provide math tutoring. We reserve the right to change the AI model at any time without notice. While we implement security measures, we do not guarantee protection against attempts to jailbreak or otherwise compromise our AI systems.</p>
        
        <h2>5. Content and Conduct</h2>
        <p>Our Service allows you to submit content, including drawings, text, and other materials. You retain ownership of any intellectual property rights that you hold in that content.</p>
        
        <h2>6. Privacy and Data Protection</h2>
        <p>Our Privacy Policy explains how we treat your personal data and protect your privacy when you use our Service. By using our Service, you agree that we can use such data in accordance with our Privacy Policy.</p>
        
        <h2>7. Modifications to the Service</h2>
        <p>We are constantly changing and improving our Service. We may add or remove functionalities or features, and we may suspend or stop a Service altogether.</p>
        
        <h2>8. Modification of Terms</h2>
        <p>We may modify these Terms at any time. We'll post any modifications to these Terms on this page and, if the changes are significant, we will provide a more prominent notice.</p>
        
        <h2>9. Disclaimer of Warranties</h2>
        <p>THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EITHER EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT.</p>
        
        <h2>10. Limitation of Liability</h2>
        <p>TO THE EXTENT PERMITTED BY LAW, THE TOTAL LIABILITY OF LINKS, ITS OFFICERS, EMPLOYEES, AND REPRESENTATIVES FOR ANY CLAIMS UNDER THESE TERMS, INCLUDING FOR ANY IMPLIED WARRANTIES, IS LIMITED TO THE AMOUNT YOU PAID US TO USE THE SERVICE.</p>
        
        <h2>11. Children's Privacy</h2>
        <p>Our Service is intended for educational purposes and may be used by children. We comply with applicable laws regarding the protection of children's data and privacy.</p>
        
        <h2>12. Governing Law</h2>
        <p>These Terms shall be governed by the laws of the United States, without regard to its conflict of law provisions.</p>
        
        <h2>13. Contact Us</h2>
        <p>If you have any questions about these Terms, please contact us at brockman.michael2003@gmail.com.</p>
      </div>
      
      {/* Back button at the bottom */}
      <div style={{ marginTop: '30px' }}>
        <Link to="/" style={{ 
          display: 'inline-block', 
          padding: '10px 20px', 
          backgroundColor: '#9CDAED', 
          color: 'black', 
          textDecoration: 'none', 
          borderRadius: '8px',
          fontWeight: 'bold'
        }}>
          Return to Home
        </Link>
      </div>
    </div>
  );
};

export default TermsOfService;